import type { Compra } from '../types/content'

export const compras: Compra[] = [
  { name: 'Marina', city: 'Buenos Aires, Argentina', product: 'Mega Pack Cocina Lista' },
  { name: 'Camila', city: 'Santiago, Chile', product: 'Mega Pack + Sistema Total' },
  { name: 'Lucía', city: 'Montevideo, Uruguay', product: 'Mega Pack Cocina Lista' },
  { name: 'Andrea', city: 'Bogotá, Colombia', product: 'Mega Pack + Sistema Total' },
  { name: 'Florencia', city: 'Rosario, Argentina', product: 'Mega Pack Cocina Lista' },
  { name: 'Paola', city: 'Ciudad de México, México', product: 'Mega Pack Cocina Lista' },
  { name: 'Gabriela', city: 'Lima, Perú', product: 'Mega Pack + Sistema Total' },
  { name: 'Verónica', city: 'Córdoba, Argentina', product: 'Mega Pack Cocina Lista' },
  { name: 'Daniela', city: 'Asunción, Paraguay', product: 'Mega Pack Cocina Lista' },
  { name: 'Carolina', city: 'Quito, Ecuador', product: 'Mega Pack + Sistema Total' },
  { name: 'Julieta', city: 'Mendoza, Argentina', product: 'Mega Pack Cocina Lista' },
  { name: 'Rocío', city: 'Miami, Estados Unidos', product: 'Mega Pack + Sistema Total' },
  { name: 'Agustina', city: 'La Plata, Argentina', product: 'Mega Pack Cocina Lista' },
  { name: 'Mariana', city: 'San José, Costa Rica', product: 'Mega Pack Cocina Lista' },
  { name: 'Silvina', city: 'Madrid, España', product: 'Mega Pack + Sistema Total' },
]
